(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowResponseQuestion', drvWorkflowResponseQuestion);

    drvWorkflowResponseQuestion.$inject = ['$q', 'WorkflowRunService', 'DialogService'];
    
    function drvWorkflowResponseQuestion($q, WorkflowRunService, DialogService) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/workflow/responses/workflow-response-question.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch(function () { return scope.step.Properties; }, function (newVal, oldVal) {
                if (angular.isDefined(newVal) && newVal !== null) {
                    scope.questionOptions = _.zip(newVal.Choices.split('|'), newVal.Values.split('|'));
                } else {
                    scope.questionOptions = [];
                }
            });

            scope.respond = function (responseValue) {
                scope.disabled = true;
                return WorkflowRunService.respondToStep(scope.instanceId, scope.step.StepId, responseValue)
                    .catch(function (response) {
                        DialogService.error('Error responding to Workflow step', response);
                        return $q.reject(response);
                    });
            };
        }
    }
})();